// @flow
import { getCreator } from '../../http';
import environment from '../../environment';

export const endpoints = Object.freeze({
  FETCH_PAYMENTS_MADE: `${environment.apiUrl}/payment/list/purchase`,
  FETCH_PAYMENTS_RECEIVED: `${environment.apiUrl}/payment/list/sale`,
});

export const getPaymentsMadeApi = getCreator(fetch, endpoints.FETCH_PAYMENTS_MADE);
export const getPaymentsReceivedApi = getCreator(fetch, endpoints.FETCH_PAYMENTS_RECEIVED);



// WEBPACK FOOTER //
// ./src/modules/payments/api.js